import { useCallback } from 'react';
import { useNavigate, type NavigateFunction } from 'react-router-dom';

/** Pop the current screen; direct links replace themselves with a safe parent. */
export function navigateAppBack(navigate: NavigateFunction, historyState: unknown, fallback: string) {
  const index = (historyState as { idx?: unknown } | null)?.idx;
  if (typeof index === 'number' && Number.isInteger(index) && index > 0) {
    navigate(-1);
  } else {
    navigate(fallback, { replace: true });
  }
}

export function useAppBack(fallback = '/calendar') {
  const navigate = useNavigate();
  return useCallback(() => {
    navigateAppBack(navigate, window.history.state, fallback);
  }, [navigate, fallback]);
}
